import React from 'react';
import Remarkable from 'react-remarkable';
import { useDispatch, useSelector } from 'react-redux';
import { Description } from './QuestConfirmationCSS';
import {
  ModalContent,
  Title,
  OptionsList,
  OptionItem,
  OptionButton,
} from './QuestSingleChoiceCSS';

const QuestSingleChoice = () => {
  const dispatch = useDispatch();
  const currentInteraction = useSelector(
    (state) => state.interaction.currentInteraction
  );

  if (!currentInteraction || currentInteraction.type !== 'questSingleChoice')
    return null;

  const { question, options, questionId, description } =
    currentInteraction.data;

  const handleOptionClick = (response) => {
    dispatch({
      type: 'INTERACTION_RESPONSE',
      payload: {
        questionId,
        response,
        isAlternative: false,
      },
    });
  };

  return (
    <ModalContent>
      <Title>{question}</Title>
      <Description>
        <Remarkable source={description ?? ''} />
      </Description>

      {/* Single choice options - horizontal layout */}
      <OptionsList>
        {options.map((option, index) => (
          <OptionItem key={index}>
            <OptionButton onClick={() => handleOptionClick(option)}>
              {option}
            </OptionButton>
          </OptionItem>
        ))}
      </OptionsList>
    </ModalContent>
  );
};

export default QuestSingleChoice;
